import { Injectable } from '@angular/core';
import {
    Router,
    RouterStateSnapshot,
    ActivatedRouteSnapshot
} from '@angular/router';
import { LocalStorageService } from '../shared/services/local-storage.service';

@Injectable({
    providedIn: 'root'
})
export class OrderResolverService {
    constructor(
        private router: Router,
        private localStorageService: LocalStorageService
    ) {}
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): void {
        const user = this.localStorageService.get('isDpdLogistic');
        const dpdTab = this.localStorageService.get('dpdTab') || 'created';
        const url = state.url;
        if (user) {
            this.router.navigateByUrl(`${url}/${dpdTab}`);
        } else if (!user) {
            this.router.navigateByUrl(`${url}/all`);
        }
    }
}
